import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const showPipelineSlice = createSlice({
  name: 'SHOW_PIPELINE',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error.message = action.payload.message;
      state.error.statusCode = action.payload.statusCode;
    },
  },
});

// REDUCER
export default showPipelineSlice.reducer;

// ACTIONS
export const { loading, success, failure } = showPipelineSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.job.create.workflow.showPipeline.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.job.create.workflow.showPipeline.success;
export const selectError = (state: RootState) =>
  state.ui.job.create.workflow.showPipeline.error;
